import React, { createContext, useReducer, useState } from "react";
import { node } from "prop-types";
import { reducer } from "../reducers";
import { GET_STORAGE, SET_STORAGE, translateKey } from "../utils";
import { Settings } from "../config/global-settings";
import config from "../config/global.config.json";

const storageSettings = GET_STORAGE("settings");
const storageVersion = GET_STORAGE("version");

if (storageVersion && storageVersion !== config.storage_version) {
    localStorage.clear();
}

const settings = storageSettings && Object.keys(storageSettings).length > 0 ? storageSettings : Settings;

const Store = ({ children }) => {
    const [settingsState, dispatch] = useReducer(reducer, settings);
    const settingsValue = { settingsState, dispatch };

    SET_STORAGE("settings", settingsState);
    SET_STORAGE("version", config.storage_version);

    return <SettingsContext.Provider value={settingsValue}>{children}</SettingsContext.Provider>;
};

export const SettingsContext = createContext(settings);

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    if (!GET_STORAGE("currentLanguage")) {
        SET_STORAGE("currentLanguage", config.defaultLanguage);
    }

    const [currentLanguage, setCurrentLanguage] = useState(GET_STORAGE("currentLanguage"));
    const [fullscreen, setFullscreen] = useState(false);

    const handleFullscreenChange = (value) => {
        setFullscreen(value);
        SET_STORAGE("fullscreen", value);
    };

    const provider = {
        currentLanguage,
        fullscreen,
        handleLanguageChange: (e) => {
            setCurrentLanguage(e?.target?.value);
            SET_STORAGE("currentLanguage", e?.target?.value);
        },
        handleFullscreenChange,
        translate: (key, values) => {
            return translateKey(key, values);
        },
    };

    return <LanguageContext.Provider value={provider}>{children}</LanguageContext.Provider>;
};

Store.propTypes = {
    children: node,
};

LanguageProvider.propTypes = {
    children: node,
};

export default Store;
